module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"CSV Handbal Castricum","short_name":"CSV Handbal","description":"Al 70 jaar is CSV actief in de wedstrijd- en breedtesport voor alle leeftijden. De vereniging bestaat uit jongens-, meiden-, heren-, dames- en rolstoelteams!","start_url":"/","background_color":"#2041a3","theme_color":"#2041a3","display":"minimal-ui","icon":"src/images/favicon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
